import type { Alert } from '../lib/api.js';

const TONE: Record<Alert['severity'], string> = {
  error: 'border-rose-700 bg-rose-950/40 text-rose-200',
  warning: 'border-amber-700 bg-amber-950/40 text-amber-200',
  info: 'border-slate-700 bg-slate-900/40 text-slate-300',
};

export function AnomaliesPanel({ alerts }: { alerts: Alert[] }) {
  return (
    <div className="rounded-xl border border-slate-700 bg-slate-800/60 p-4">
      <h2 className="mb-3 text-sm font-medium text-slate-200">Anomalías y alertas</h2>
      {alerts.length === 0 ? (
        <p className="text-sm text-emerald-400">Sin alertas. Todo en orden.</p>
      ) : (
        <ul className="space-y-2">
          {alerts.map((a, i) => (
            <li
              key={`${a.code}-${i}`}
              className={`rounded-lg border px-3 py-2 text-sm ${TONE[a.severity]}`}
            >
              {a.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
